import React, { useContext, useEffect, useState } from "react";
import { Button } from "reactstrap";

import "./styles/main.css";
import { default as leftArrow } from "./resources/left-arrow-svgrepo-com.svg";

import { SITE_URL } from "./serverConfig";
import DesktopSiteView from "./details/DesktopSiteView";
import Dashboard from "./features/dashboard/Dashboard";
import MobileSiteView from "./details/MobileSiteView";
import StationLog from "./features/station-log/StationLog";
import Admin from "./features/admin/Admin";
import { RestContext } from "./App";
import SiteSelectMenu from "./components/SiteSelectMenu";
import SideNav from "./SideNav";
import { checkMobile } from "./util/globals";
import Checklists from "./features/checklist/Checklists";
import Data from "./features/data/Data";
import SiteDetails from "./details/SiteDetails";

export default function Main({
	openFeature,
	siteList,
	isMobile,
	user,
	navOpen,
	onSelectFeature,
}) {
	const [selectedSite, setSelectedSite] = useState("all");
	const [siteDetails, setSiteDetails] = useState();
	const [siteSelectMenuOpen, setSiteSelectMenuOpen] = useState(false);

	const { sendPostRequest } = useContext(RestContext);

	const toggleSiteSelectMenuOpen = () =>
		setSiteSelectMenuOpen(!siteSelectMenuOpen);

	useEffect(() => {
		if (selectedSite !== undefined) {
			if (selectedSite === "all") {
				setSiteDetails();
			} else {
				sendPostRequest(
					SITE_URL + "/details",
					{ siteId: selectedSite },
					(response) => {
						setSiteDetails(response.data);
					},
				);
			}
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedSite]);

	const getOptionText = (site) => {
		if (site.fullName === "All Sites") {
			return site.fullName;
		} else {
			return `${site.siteAbbr}: ${site.fullName}`;
		}
	};

	const getOptionValue = (site) => {
		if (site.fullName === "All Sites") {
			return "all";
		} else {
			return site.siteId;
		}
	};

	const mapSiteListToOptions = () => {
		return siteList.map((site, index) => (
			<option
				key={"site-select-option-" + index}
				site={site.siteAbbr}
				value={getOptionValue(site)}
			>
				{getOptionText(site)}
			</option>
		));
	};

	const getRenderedContent = () => {
		switch (openFeature) {
			case "dashboard":
				return (
					<Dashboard
						selectedSite={selectedSite}
						siteDetails={siteDetails}
					/>
				);
			case "station-log":
				return (
					<StationLog
						selectedSite={selectedSite}
						siteDetails={siteDetails}
					/>
				);
			case "administration":
				return <Admin selectedSite={selectedSite} />;
			case "checklist":
				return <Checklists selectedSite={selectedSite} />;
			case "stripchart":
				return (
					<Data
						selectedSite={selectedSite}
						openFeature={openFeature}
					/>
				);
			case "stackplot":
				return (
					<Data
						selectedSite={selectedSite}
						openFeature={openFeature}
					/>
				);
			case "stackplot-editor":
				return (
					<Data
						selectedSite={selectedSite}
						openFeature={openFeature}
					/>
				);
			case "stack-batch":
				return (
					<Data
						selectedSite={selectedSite}
						openFeature={openFeature}
					/>
				);
			case "stack-batch-editor":
				return (
					<Data
						selectedSite={selectedSite}
						openFeature={openFeature}
					/>
				);
			case "validation":
				return (
					<Data
						selectedSite={selectedSite}
						openFeature={openFeature}
					/>
				);
			case "tables":
				return (
					<Data
						selectedSite={selectedSite}
						openFeature={openFeature}
					/>
				);
			case "site-details":
				return <SiteDetails site={siteDetails} user={user} />;
			default:
				return null;
		}
	};

	const handleEnter = (event) => {
		if (event.key === "Enter") {
			event.preventDefault();
			toggleSiteSelectMenuOpen();
		}
	};

	const renderSideNav = () => {
		if (checkMobile()) return null;
		return <SideNav isOpen={navOpen} onSelectFeature={onSelectFeature} />;
	};

	return (
		<main>
			{renderSideNav()}
			<div id="main-wrapper">
				<div id="site-select-wrapper">
					<select
						id="site-select"
						onMouseDown={(e) => e.preventDefault()}
						onClick={toggleSiteSelectMenuOpen}
						onKeyDown={handleEnter}
						value={selectedSite}
						disabled={siteList.length === 0}
					>
						{mapSiteListToOptions()}
					</select>
					<SiteSelectMenu
						isOpen={siteSelectMenuOpen}
						toggle={toggleSiteSelectMenuOpen}
						selectedSite={selectedSite}
						setSelectedSite={setSelectedSite}
						siteList={siteList}
					/>
				</div>
				<div id="main-content">{getRenderedContent()}</div>
			</div>
		</main>
	);
}
